import React from 'react';
import { Box, Typography } from '@mui/material';
import PublicNavbar from '../../components/public/PublicNavbar';
import PricingCards from '../../components/public/PricingCards';
import { PublicFooter } from '../../components/public/landingSections';
import type { PublicPlan } from '../../services/billing';

const PricingPage: React.FC = () => {
  const [plans, setPlans] = React.useState<PublicPlan[] | null>(null);

  React.useEffect(() => {
    if (process.env.NODE_ENV === 'test') return undefined;
    let cancelled = false;
    import('../../services/billing')
      .then(({ default: billingService }) => billingService.catalog())
      .then((rows) => {
        if (!cancelled) setPlans(rows);
      })
      .catch(() => {
        if (!cancelled) setPlans([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <PublicNavbar />
      <Box
        id="main"
        component="main"
        tabIndex={-1}
        sx={{ px: { xs: 2, sm: 3 }, py: { xs: 4, md: 6 }, maxWidth: 1100, mx: 'auto' }}
      >
        {plans && plans.length > 0 ? (
          <PricingCards plans={plans} />
        ) : (
          <Box component="section" id="pricing" aria-labelledby="pricing-heading" aria-busy={plans === null}>
            <Typography id="pricing-heading" variant="h1" sx={{ fontWeight: 800, fontSize: { xs: 32, md: 44 }, mb: 1 }}>
              Simple pricing
            </Typography>
            <Typography color="text.secondary">
              {plans === null
                ? 'Loading the plan catalog…'
                : 'Plan prices are not available from the catalog right now. The Free plan does not require a credit card.'}
            </Typography>
          </Box>
        )}
        <PublicFooter />
      </Box>
    </Box>
  );
};

export default PricingPage;
